import { GlobalController } from 'src/shared/global/GlobalController'
import ServiceObservation from './ServiceObservation'
const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}
export const routes = [
  {
    path: 'registration-information/observation-unit',
    name:
        'serviceRequest.registration-information.observation-unit',
    component: ServiceObservation,
    beforeEnter: ifAuthenticated,
    props: true,
    meta: {
      fillContainer: true
    }
  }
]
